import { render } from "./Checkin.vue?vue&type=template&id=5a94fe16"
import script from "./Checkin.vue?vue&type=script&lang=js"
export * from "./Checkin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/MAR WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__